import { defineAction } from '~/prix'
import { z } from 'zod'
import waterSourceApplicationDeleteAction from './waterSourceApplicationDelete.action.json' with { type: 'json' }
import { waterSourceApplicationObject } from '../waterSourceApplicationObject'

const waterSourceApplicationDeleteDefinition = defineAction({
  ...waterSourceApplicationDeleteAction,

  input: waterSourceApplicationObject.pick({ id: true }).required({ id: true }),
  output: z.object({}),
})

export default waterSourceApplicationDeleteDefinition
